import { render } from "./WhiteBook.vue?vue&type=template&id=971f3a32"
import script from "./WhiteBook.vue?vue&type=script&lang=js"
export * from "./WhiteBook.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__